<template>
  <router-view>

  </router-view>
</template>

<script setup>

</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */

  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
}
</style>
